import Joi from 'joi';

export const createLayout = () => ({
    name: { label: 'filter', control: 'text' },
});

export const createSchema = () => {
    const layout = createLayout();
    return {
        name: Joi.string().max(256).allow(null, '').label(layout.name.label),
    };
};

export const createEmpty = () => ({
    name: '',
});
